module.exports = __webpack_public_path__ + "img/icon.b3ebbefe.png";